var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindWalker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2101160",
    "data-name": 2101160,
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.346,
    height: 58.495,
    viewBox: "0 0 58.346 58.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1950",
    "data-name": "Group 1950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1836",
    "data-name": "Group 1836",
    transform: "translate(0 56.051)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 27.249,
    cy: 1.222,
    rx: 27.249,
    ry: 1.222,
    fill: "#32324c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1911",
    "data-name": "Group 1911",
    transform: "translate(2.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1843",
    "data-name": "Group 1843",
    transform: "translate(1.919 25.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1839",
    "data-name": "Group 1839",
    transform: "translate(0 30.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    "data-name": "Group 1838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1837",
    "data-name": "Group 1837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4204",
    "data-name": "Path 4204",
    d: "M78.416,213.372a3.906,3.906,0,0,0-.428,1.894h6.323a4.075,4.075,0,0,0-3.941-1.955Z",
    transform: "translate(-77.983 -213.271)",
    fill: "#3a3a99"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1841",
    "data-name": "Group 1841",
    transform: "translate(0.464 1.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1840",
    "data-name": "Group 1840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4205",
    "data-name": "Path 4205",
    d: "M91.322,119.8l-5.346,16.924-4.246,11.7H79.5s.916-5.59,1.558-7.668c1.039-3.36,1.5-5.132,2.261-7.148l2.5-13.044Z",
    transform: "translate(-79.5 -119.8)",
    fill: "#fa8b67"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1842",
    "data-name": "Group 1842",
    transform: "translate(3.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4206",
    "data-name": "Path 4206",
    d: "M98.615,116.244l-3.36,13.2A10.858,10.858,0,0,1,90,127.914l2.2-13.074S97.973,113.984,98.615,116.244Z",
    transform: "translate(-90 -114.68)",
    fill: "#32324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1850",
    "data-name": "Group 1850",
    transform: "translate(4.703 25.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1846",
    "data-name": "Group 1846",
    transform: "translate(10.754 28.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1845",
    "data-name": "Group 1845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1844",
    "data-name": "Group 1844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4207",
    "data-name": "Path 4207",
    d: "M122.359,210.762a3.858,3.858,0,0,0,.153,1.955l6.018-1.986a4.076,4.076,0,0,0-4.277-.58Z",
    transform: "translate(-122.297 -209.778)",
    fill: "#3a3a99"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1848",
    "data-name": "Group 1848",
    transform: "translate(0.002 0.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1847",
    "data-name": "Group 1847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4208",
    "data-name": "Path 4208",
    d: "M87.1,117.75c.092,3.055,2.474,8.645,4.521,13.349a24.6,24.6,0,0,0,1.772,5.682c1.344,2.81,4.491,9.714,4.491,9.714l1.863-.611-4.093-15.946L91.9,117.2Z",
    transform: "translate(-87.1 -117.2)",
    fill: "#ffb184"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1849",
    "data-name": "Group 1849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4209",
    "data-name": "Path 4209",
    d: "M87.1,117.648a27.466,27.466,0,0,0,3.116,12.127s3.91.153,6.262-1.314l-3.36-10.234A5.754,5.754,0,0,0,87.1,117.648Z",
    transform: "translate(-87.094 -117.053)",
    fill: "#434361"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1855",
    "data-name": "Group 1855",
    transform: "translate(12.372 9.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1852",
    "data-name": "Group 1852",
    transform: "translate(2.138 7.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1851",
    "data-name": "Group 1851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4210",
    "data-name": "Path 4210",
    d: "M125.951,94.077c-.305-.122-.672-.244-1.039-.367a19.712,19.712,0,0,1-4.4-2.81L119.2,92.488a2.129,2.129,0,0,0,1.558,1.65l4.7,1.405C125.615,95.024,125.768,94.566,125.951,94.077Z",
    transform: "translate(-119.2 -90.9)",
    fill: "#ffb184"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1854",
    "data-name": "Group 1854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1853",
    "data-name": "Group 1853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4211",
    "data-name": "Path 4211",
    d: "M112.658,64.8l2.994,7.942-1.344,1.833L112.2,70.482Z",
    transform: "translate(-112.2 -64.8)",
    fill: "#651fd0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1865",
    "data-name": "Group 1865",
    transform: "translate(3.513 9.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1857",
    "data-name": "Group 1857",
    transform: "translate(0.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1856",
    "data-name": "Group 1856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4212",
    "data-name": "Path 4212",
    d: "M93.961,79.934a2.023,2.023,0,0,1-1.252,1.191c-.061,0-.092.031-.153.031a1.533,1.533,0,0,1-.367.061,21.206,21.206,0,0,1-3.666.305,5.967,5.967,0,0,1-.7-.061.275.275,0,0,1-.153-.031,5.983,5.983,0,0,1-3.146-1.741l.061-.367.122-.611.4-2.261.092-.611.092-.55-.305-1.833-.122-.642-.4-2.413-.092-.642-.4-2.383-.122-.642-.458-2.322-.092-.611v-.061l2.658-.916.153-.061.58-.214.061-.031.153-.031.367-.092,2.81.367h.031l.153.031.153.031.153.031,2.016.275v.031l.061.642.214,2.535.061.642.214,2.535.061.611.214,2.535.061.611.214,2.535.061.611.214,2.535.061.611Z",
    transform: "translate(-83.3 -62.4)",
    fill: "#7335da"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1864",
    "data-name": "Group 1864",
    transform: "translate(0 0.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1858",
    "data-name": "Group 1858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4213",
    "data-name": "Path 4213",
    d: "M92.578,65.442a21.633,21.633,0,0,1-6.171.733c-1.283,0-2.413-.061-3.116-.122l-.092-.611c1.588.122,6.415.4,9.317-.642Z",
    transform: "translate(-83.2 -64.8)",
    fill: "#651fd0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1859",
    "data-name": "Group 1859",
    transform: "translate(0.489 3.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4214",
    "data-name": "Path 4214",
    d: "M93.934,75.842a18.414,18.414,0,0,1-5.376.672c-1.436,0-2.749-.092-3.635-.183l-.122-.642c1.833.183,6.2.489,9.073-.489Z",
    transform: "translate(-84.8 -75.2)",
    fill: "#651fd0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1860",
    "data-name": "Group 1860",
    transform: "translate(1.069 6.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4215",
    "data-name": "Path 4215",
    d: "M95.528,86.141a16.524,16.524,0,0,1-4.8.58,32.988,32.988,0,0,1-3.941-.244l-.092-.641c1.986.244,5.957.58,8.8-.336Z",
    transform: "translate(-86.7 -85.5)",
    fill: "#651fd0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    "data-name": "Group 1861",
    transform: "translate(1.558 9.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4216",
    "data-name": "Path 4216",
    d: "M96.884,96.611a15.918,15.918,0,0,1-4.338.519,30.061,30.061,0,0,1-4.124-.305l-.122-.642A22.02,22.02,0,0,0,96.853,96Z",
    transform: "translate(-88.3 -96)",
    fill: "#651fd0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862",
    transform: "translate(1.741 12.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4217",
    "data-name": "Path 4217",
    d: "M97.545,107.011a14.882,14.882,0,0,1-4.032.489,26.673,26.673,0,0,1-4.613-.428l.092-.611a20.25,20.25,0,0,0,8.462-.061Z",
    transform: "translate(-88.9 -106.4)",
    fill: "#651fd0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    "data-name": "Group 1863",
    transform: "translate(1.283 15.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4218",
    "data-name": "Path 4218",
    d: "M96.778,116.755a14.225,14.225,0,0,1-3.757.458,25.974,25.974,0,0,1-5.621-.7l.122-.611c1.833.428,5.835,1.161,9.225.244Z",
    transform: "translate(-87.4 -115.9)",
    fill: "#651fd0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1904",
    "data-name": "Group 1904",
    transform: "translate(6.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1903",
    "data-name": "Group 1903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1867",
    "data-name": "Group 1867",
    transform: "translate(6.212 1.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1866",
    "data-name": "Group 1866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4219",
    "data-name": "Path 4219",
    d: "M113.589,39.1a1.6,1.6,0,0,1,.305,1.772c-.367,1.252-.855,1.314-.855,1.314S112.55,39.314,113.589,39.1Z",
    transform: "translate(-112.924 -39.1)",
    fill: "#32324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1869",
    "data-name": "Group 1869",
    transform: "translate(0.828 6.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1868",
    "data-name": "Group 1868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4220",
    "data-name": "Path 4220",
    d: "M98.08,55.988,97.8,57.577l-.122.733c-1.008.58-2.383-.55-2.383-.55l.153-2.5c.458-.244,1.466.275,2.108.519A5.437,5.437,0,0,1,98.08,55.988Z",
    transform: "translate(-95.3 -55.191)",
    fill: "#ffb184"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1871",
    "data-name": "Group 1871",
    transform: "translate(1.561 7.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1870",
    "data-name": "Group 1870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4221",
    "data-name": "Path 4221",
    d: "M99.747,56.967l-.275,1.588C98.433,58.188,97.7,56.6,97.7,56.6l1.527.183A3.094,3.094,0,0,1,99.747,56.967Z",
    transform: "translate(-97.7 -56.6)",
    fill: "#fa8b67"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1873",
    "data-name": "Group 1873",
    transform: "translate(0.278 0.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1872",
    "data-name": "Group 1872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4222",
    "data-name": "Path 4222",
    d: "M100.251,38.391a.229.229,0,0,1-.031.153,15.214,15.214,0,0,1-.275,1.558,1.3,1.3,0,0,0-.061.336c-.031.092-.031.183-.061.275-.061.214-.092.4-.153.58-.031.122-.061.275-.092.4a2.106,2.106,0,0,1-.092.244,2.028,2.028,0,0,1-.458.642A1.954,1.954,0,0,1,97.2,43c-.55-.153-1.13-.367-1.711-.55-.031,0-.061-.031-.092-.031a7.262,7.262,0,0,1-1.191-.55c-.031-.061-.092-.153-.122-.214a6.18,6.18,0,0,1-.55-1.986,7.442,7.442,0,0,1-.031-.825v-.061c.122-1.375.336-2.719.336-2.719,1.68-1.741,5.8-.642,6.323.794A3.985,3.985,0,0,1,100.251,38.391Z",
    transform: "translate(-93.5 -35.177)",
    fill: "#ffb184"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1875",
    "data-name": "Group 1875",
    transform: "translate(0.339 5.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1874",
    "data-name": "Group 1874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4223",
    "data-name": "Path 4223",
    d: "M94.25,52.086A6.18,6.18,0,0,1,93.7,50.1a1.875,1.875,0,0,1,.794.305A7.6,7.6,0,0,1,94.25,52.086Z",
    transform: "translate(-93.7 -50.1)",
    fill: "#32324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1877",
    "data-name": "Group 1877",
    transform: "translate(4.005 4.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1876",
    "data-name": "Group 1876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4224",
    "data-name": "Path 4224",
    d: "M106.128,47.1c-.031.214-.122.367-.244.367s-.183-.183-.183-.4c.031-.214.122-.367.244-.367S106.158,46.883,106.128,47.1Z",
    transform: "translate(-105.7 -46.7)",
    fill: "#32324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1879",
    "data-name": "Group 1879",
    transform: "translate(6.083 4.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1878",
    "data-name": "Group 1878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4225",
    "data-name": "Path 4225",
    d: "M112.928,47.7c-.031.214-.122.367-.244.367s-.183-.183-.183-.4c.031-.214.122-.367.244-.367S112.958,47.483,112.928,47.7Z",
    transform: "translate(-112.5 -47.3)",
    fill: "#32324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1881",
    "data-name": "Group 1881",
    transform: "translate(0.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1880",
    "data-name": "Group 1880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4226",
    "data-name": "Path 4226",
    d: "M93.548,36.589a.928.928,0,0,1,1.222.458l.428.031A4.443,4.443,0,0,1,95.5,35.7c.244-.458,1.1-.4,1.283-.947,0,0,2.047,1.314,3.391.55,1.5-.825-2.78-3.269-5.01-2.413C93.457,33.565,93.365,35.031,93.548,36.589Z",
    transform: "translate(-93.482 -32.714)",
    fill: "#32324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1883",
    "data-name": "Group 1883",
    transform: "translate(3.364 3.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1882",
    "data-name": "Group 1882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4227",
    "data-name": "Path 4227",
    d: "M103.6,44.82a1.053,1.053,0,0,1,.642-.458,1.122,1.122,0,0,1,.733.122c.061.031.061.092.031.153h0a.147.147,0,0,1-.183.061A1.141,1.141,0,0,0,103.6,44.82Z",
    transform: "translate(-103.6 -44.345)",
    fill: "#32324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1885",
    "data-name": "Group 1885",
    transform: "translate(5.918 3.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1884",
    "data-name": "Group 1884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4228",
    "data-name": "Path 4228",
    d: "M113.072,45.123a.229.229,0,0,1-.031.153,1.059,1.059,0,0,0-.886-.092h-.061c-.061,0-.092-.031-.122-.092a.112.112,0,0,1,.061-.153,1.038,1.038,0,0,1,.764,0Z",
    transform: "translate(-111.961 -44.869)",
    fill: "#32324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1892",
    "data-name": "Group 1892",
    transform: "translate(0 3.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1887",
    "data-name": "Group 1887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1886",
    "data-name": "Group 1886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4229",
    "data-name": "Path 4229",
    d: "M94.15,45.593s-.611-.886-1.222-.458a1.454,1.454,0,0,0,.916,2.352Z",
    transform: "translate(-92.589 -45.018)",
    fill: "#ffb184"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1889",
    "data-name": "Group 1889",
    transform: "translate(0.602 0.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1888",
    "data-name": "Group 1888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4230",
    "data-name": "Path 4230",
    d: "M95.306,48.509a.131.131,0,0,1-.122-.122c-.031-.916-.55-1.1-.55-1.1a.116.116,0,1,1,.092-.214c.031,0,.7.244.733,1.314a.156.156,0,0,1-.153.122Z",
    transform: "translate(-94.561 -47.061)",
    fill: "#fa8b67"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1891",
    "data-name": "Group 1891",
    transform: "translate(0.561 1.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1890",
    "data-name": "Group 1890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4231",
    "data-name": "Path 4231",
    d: "M94.54,49.028A.112.112,0,0,1,94.448,49a.139.139,0,0,1,0-.153.614.614,0,0,1,.611-.122.116.116,0,0,1-.092.214.474.474,0,0,0-.4.061C94.6,49,94.57,49.028,94.54,49.028Z",
    transform: "translate(-94.425 -48.688)",
    fill: "#fa8b67"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1894",
    "data-name": "Group 1894",
    transform: "translate(5.227 4.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1893",
    "data-name": "Group 1893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4232",
    "data-name": "Path 4232",
    d: "M109.822,49.036c-.031,0-.061-.031-.092-.061-.031-.061-.031-.122.031-.153l.305-.214-.244-.092c-.031,0-.061-.061-.061-.092l-.061-.7c0-.061.031-.122.092-.122s.122.031.122.092l.031.642.4.153c.031,0,.061.061.061.092s0,.092-.061.092l-.519.336C109.853,49.036,109.853,49.036,109.822,49.036Z",
    transform: "translate(-109.7 -47.6)",
    fill: "#fa8b67"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1896",
    "data-name": "Group 1896",
    transform: "translate(3.646 6.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1895",
    "data-name": "Group 1895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4233",
    "data-name": "Path 4233",
    d: "M105.953,54.951a2.018,2.018,0,0,1-1.405-.55.108.108,0,0,1,.153-.153,1.965,1.965,0,0,0,1.925.4.116.116,0,0,1,.092.214A3.564,3.564,0,0,1,105.953,54.951Z",
    transform: "translate(-104.525 -54.225)",
    fill: "#fa8b67"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1898",
    "data-name": "Group 1898",
    transform: "translate(3.921 7.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1897",
    "data-name": "Group 1897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4234",
    "data-name": "Path 4234",
    d: "M106.242,57.337a.958.958,0,0,1-.794-.336.108.108,0,1,1,.153-.153.866.866,0,0,0,.916.214c.061,0,.122.031.122.092s-.031.122-.092.122A.551.551,0,0,1,106.242,57.337Z",
    transform: "translate(-105.425 -56.825)",
    fill: "#fa8b67"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1900",
    "data-name": "Group 1900",
    transform: "translate(4.616 0.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1899",
    "data-name": "Group 1899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4235",
    "data-name": "Path 4235",
    d: "M107.7,33.259a5.084,5.084,0,0,0,2.413-.061c1.222-.4,1.68,1.955.183,2.291C108.83,35.794,107.7,33.259,107.7,33.259Z",
    transform: "translate(-107.7 -33.153)",
    fill: "#32324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1902",
    "data-name": "Group 1902",
    transform: "translate(1.549 4.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1901",
    "data-name": "Group 1901"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4236",
    "data-name": "Path 4236",
    d: "M102.192,48.794a2.98,2.98,0,0,1-1.711-.244,1.88,1.88,0,0,0-.7-.214,2.535,2.535,0,0,0-1.252.275,5.271,5.271,0,0,1-.428-1.68l-.428-.031a10.434,10.434,0,0,0,.214,2.719,3.242,3.242,0,0,0,.489,1.039,2.9,2.9,0,0,0,1.069.947,1.7,1.7,0,0,0,.794.244,2.4,2.4,0,0,0,2.291-2.444l-.092-.092c-.183,1.039-.764,1.527-1.344,1.527a2.563,2.563,0,0,1-1.925-1.161.52.52,0,0,1,.55-.794h0a4.12,4.12,0,0,1,1.069.428c.367.153.55.031.855,0,.58-.092.764.092.855.214a.621.621,0,0,0,.183-.275,1.045,1.045,0,0,0,.031-.336C102.681,48.733,102.5,48.763,102.192,48.794Z",
    transform: "translate(-97.658 -46.9)",
    fill: "#32324c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1910",
    "data-name": "Group 1910",
    transform: "translate(0 10.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1908",
    "data-name": "Group 1908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1905",
    "data-name": "Group 1905",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4237",
    "data-name": "Path 4237",
    d: "M76.618,71.221A23.843,23.843,0,0,0,74.3,76.17a3.839,3.839,0,0,0-.122.367,4.347,4.347,0,0,1-2.474-.7c.4-3.6,3.513-9.134,3.513-9.134C77.412,68.075,76.618,71.221,76.618,71.221Z",
    transform: "translate(-71.7 -66.7)",
    fill: "#7335da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1906",
    "data-name": "Group 1906",
    transform: "translate(0 9.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4238",
    "data-name": "Path 4238",
    d: "M74.144,97.3s.794,1.772,1.436,3.421c.4.978,2.077,4.216,2.077,4.216l-1.1,1.008S71.7,100.816,71.7,96.6Z",
    transform: "translate(-71.7 -96.6)",
    fill: "#7335da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1907",
    "data-name": "Group 1907",
    transform: "translate(4.857 17.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4239",
    "data-name": "Path 4239",
    d: "M88.7,124s.642.214.794.519a6.685,6.685,0,0,1-.122,2.23,8.121,8.121,0,0,1-1.772-1.741Z",
    transform: "translate(-87.6 -124)",
    fill: "#ffb184"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1909",
    "data-name": "Group 1909",
    transform: "translate(1.282 9.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4240",
    "data-name": "Path 4240",
    d: "M77.212,97.378a3.831,3.831,0,0,0-.122.367s-.153-.305-1.191-.336A1.551,1.551,0,0,1,77.212,97.378Z",
    transform: "translate(-75.897 -97.236)",
    fill: "#651fd0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1949",
    "data-name": "Group 1949",
    transform: "translate(22.911 20.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1944",
    "data-name": "Group 1944",
    transform: "translate(0.764 3.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1943",
    "data-name": "Group 1943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1938",
    "data-name": "Group 1938",
    transform: "translate(7.376 14.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1913",
    "data-name": "Group 1913",
    transform: "translate(3.609 10.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1912",
    "data-name": "Group 1912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4241",
    "data-name": "Path 4241",
    d: "M176.472,191.51a3.2,3.2,0,0,0,2.108,3.391l2.871,4.582,2.5-.428s-.092-1.894-2.077-.7l-1.68-3.7a4.273,4.273,0,0,0-.305-3.513C179.924,191.174,177.113,190.808,176.472,191.51Z",
    transform: "translate(-176.459 -191.075)",
    fill: "#c18005"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1915",
    "data-name": "Group 1915",
    transform: "translate(11.655 9.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1914",
    "data-name": "Group 1914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4242",
    "data-name": "Path 4242",
    d: "M206.374,189.388a2.225,2.225,0,0,0-.305,3.116s-2.2,2.322-3.269,3.757l.55,1.8h2.5a1.46,1.46,0,0,0-1.711-.794s.092-.642-.275-.764l2.322-1.955s3.788-.7,3.757-3.7C209.948,187.83,206.374,189.388,206.374,189.388Z",
    transform: "translate(-202.8 -188.987)",
    fill: "#c18005"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1917",
    "data-name": "Group 1917",
    transform: "translate(2.581 1.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1916",
    "data-name": "Group 1916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4243",
    "data-name": "Path 4243",
    d: "M197.809,167.518a1.683,1.683,0,0,1-.519.611,2.157,2.157,0,0,1-2.138.4l-.733-.244a.892.892,0,0,0-.275-.061h0a4.3,4.3,0,0,0-.611-.031,1.922,1.922,0,0,0-.947.367,1.976,1.976,0,0,0-.275.244l-.275.305a18.588,18.588,0,0,0-2.2,2.9,1.494,1.494,0,0,1-.489.489c-1.711.978-1.68.855-4,.55a3.812,3.812,0,0,0-.641-.061h0a11.858,11.858,0,0,1-6.323.153c-.061.031-.153.031-.214.061-2.077.55-5.163.55-5.071-2.413a3.8,3.8,0,0,1,2.291-3.666c1.772-.978,5.468-1.069,8.767-.886h0c.092,0,.489.031,1.008.061a9.574,9.574,0,0,0,3.055-.153c1.1-.428,1.65-3.544,3.6-3.544s4.063,1.863,3.6,3.574l1.894,1.069Z",
    transform: "translate(-173.093 -162.6)",
    fill: "#e09f00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1919",
    "data-name": "Group 1919",
    transform: "translate(19.652 1.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1918",
    "data-name": "Group 1918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4244",
    "data-name": "Path 4244",
    d: "M229.748,162.146a9.694,9.694,0,0,0-.764,3.727c.092,1.772,1.222.611,2.016-.55s1.68-2.627,1.68-2.627C233.047,162.6,231.245,161.5,229.748,162.146Z",
    transform: "translate(-228.978 -161.946)",
    fill: "#c18005"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1921",
    "data-name": "Group 1921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1920",
    "data-name": "Group 1920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4245",
    "data-name": "Path 4245",
    d: "M168.145,167.3a1.576,1.576,0,0,1-.916.367,4.016,4.016,0,0,1-2.474-2.6c-.55-1.955,1.039-6.079,3.757-6.873h0s-1.772,2.627-1.772,4.735c0,2.871,2.077,2.138,2.077,2.138A2.6,2.6,0,0,1,168.145,167.3Z",
    transform: "translate(-164.646 -158.2)",
    fill: "#e09f00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1923",
    "data-name": "Group 1923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1922",
    "data-name": "Group 1922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4246",
    "data-name": "Path 4246",
    d: "M168.145,167.3a1.576,1.576,0,0,1-.916.367,4.016,4.016,0,0,1-2.474-2.6c-.55-1.955,1.039-6.079,3.757-6.873a6.628,6.628,0,0,0-2.688,3.757c-.55,2.413-.183,4.8,1.711,5.071C167.87,167.12,168.053,167.181,168.145,167.3Z",
    transform: "translate(-164.646 -158.2)",
    fill: "#c18005"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1925",
    "data-name": "Group 1925",
    transform: "translate(23.661 4.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1924",
    "data-name": "Group 1924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4247",
    "data-name": "Path 4247",
    d: "M242.589,171.9a.246.246,0,1,1-.275-.214A.214.214,0,0,1,242.589,171.9Z",
    transform: "translate(-242.1 -171.681)",
    fill: "#2c2a40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1927",
    "data-name": "Group 1927",
    transform: "translate(26.568 6.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1926",
    "data-name": "Group 1926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4248",
    "data-name": "Path 4248",
    d: "M252.346,178.144a1.684,1.684,0,0,1-.519.611h0a.366.366,0,0,1-.153-.519l.214-.336Z",
    transform: "translate(-251.618 -177.9)",
    fill: "#2c2a40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1929",
    "data-name": "Group 1929",
    transform: "translate(14.087 9.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1928",
    "data-name": "Group 1928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4249",
    "data-name": "Path 4249",
    d: "M210.772,190.972a3.2,3.2,0,0,0,2.108,3.391l2.872,4.582,2.5-.428s-.092-1.894-2.077-.7l-1.191-2.658s1.191-3.36.153-4.857C215.14,190.331,211.413,190.269,210.772,190.972Z",
    transform: "translate(-210.759 -190.3)",
    fill: "#e09f00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1931",
    "data-name": "Group 1931",
    transform: "translate(0.75 9.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1930",
    "data-name": "Group 1930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4250",
    "data-name": "Path 4250",
    d: "M170.674,189.388a2.225,2.225,0,0,0-.305,3.116s-2.2,2.322-3.269,3.757l.55,1.8h2.5a1.46,1.46,0,0,0-1.711-.794s.092-.642-.275-.764l2.322-1.955s3.788-.7,3.757-3.7C174.248,187.83,170.674,189.388,170.674,189.388Z",
    transform: "translate(-167.1 -188.987)",
    fill: "#e09f00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1933",
    "data-name": "Group 1933",
    transform: "translate(6.859 9.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1932",
    "data-name": "Group 1932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4251",
    "data-name": "Path 4251",
    d: "M188.505,191.338c-.122.031-.275.061-.4.092.031-.733-.031-2.138-1.008-2.444C187.1,188.986,188.841,188.742,188.505,191.338Z",
    transform: "translate(-187.1 -188.98)",
    fill: "#c18005"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1935",
    "data-name": "Group 1935",
    transform: "translate(7.898 9.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1934",
    "data-name": "Group 1934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4252",
    "data-name": "Path 4252",
    d: "M196.823,190.388h0a11.858,11.858,0,0,1-6.323.153,2.552,2.552,0,0,1,.4-1.008,2.63,2.63,0,0,0,2.23.916,6.059,6.059,0,0,0,3.238-.916s-.214-1.375.794-1.833C197.129,187.731,196.4,188.464,196.823,190.388Z",
    transform: "translate(-190.5 -187.7)",
    fill: "#c18005"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1937",
    "data-name": "Group 1937",
    transform: "translate(21.095 6.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1936",
    "data-name": "Group 1936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4253",
    "data-name": "Path 4253",
    d: "M235.625,180.553a1.922,1.922,0,0,0-.947.367,2.876,2.876,0,0,1-.978-.519C234.342,180.492,235.105,180.522,235.625,180.553Z",
    transform: "translate(-233.7 -180.4)",
    fill: "#c18005"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1940",
    "data-name": "Group 1940",
    transform: "translate(24.102 19.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1939",
    "data-name": "Group 1939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4254",
    "data-name": "Path 4254",
    d: "M220.439,173.8a3.006,3.006,0,0,0-1.039.275s2.2,3.391,4.063,3.971a1.315,1.315,0,0,0,.458-.489S220.988,175.541,220.439,173.8Z",
    transform: "translate(-219.4 -173.8)",
    fill: "#7335da"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1942",
    "data-name": "Group 1942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1941",
    "data-name": "Group 1941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4255",
    "data-name": "Path 4255",
    d: "M165,129.939c-1.741-4.735-6.476-6.476-11.028-8.156a37.719,37.719,0,0,1-5.468-2.322,17.913,17.913,0,0,1-6.568-6.171,12.166,12.166,0,0,1-1.436-3.3l.458-.092a10.9,10.9,0,0,0,1.375,3.177,17.291,17.291,0,0,0,6.415,5.987,36.884,36.884,0,0,0,5.407,2.291c4.643,1.711,9.47,3.482,11.3,8.4Z",
    transform: "translate(-140.5 -109.9)",
    fill: "#7335da"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1946",
    "data-name": "Group 1946",
    transform: "translate(0 0.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1945",
    "data-name": "Group 1945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4256",
    "data-name": "Path 4256",
    d: "M140.963,101.4s.214-.153-.061-.519-2.291-.183-2.291-.183a1.852,1.852,0,0,0-.611,1.466s1.772,1.711,1.894,1.741c.122,0,.489.183.7-.214a.655.655,0,0,0,.275-.794.709.709,0,0,0,.4-.611.36.36,0,0,0,.183-.4C141.391,101.582,140.963,101.4,140.963,101.4Z",
    transform: "translate(-138 -100.65)",
    fill: "#ffb184"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1948",
    "data-name": "Group 1948",
    transform: "translate(0.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1947",
    "data-name": "Group 1947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4257",
    "data-name": "Path 4257",
    d: "M140.077,101.948s-.244.642-.092.916c.153.305,3.421,1.65,3.208-1.405-.214-3.513-2.413-1.711-2.413-1.711l.642.061a.751.751,0,0,1,.978.183,2.65,2.65,0,0,1,.183,2.474c-.275.764-1.283.519-1.833.275a.169.169,0,0,1-.092-.244l-.092-.122Z",
    transform: "translate(-139.936 -99.287)",
    fill: "#7335da"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindWalker);
export default __webpack_public_path__ + "static/media/FindWalker.c227840d1197365be27147424d132b17.svg";
export { ForwardRef as ReactComponent };